export class Fostplus {
	ID:number = 0;
	Code:string = "";
	Amount:number = 0.0;
	Year:number = 0.0;

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.Code = data.Code;
		this.Amount = data.Amount;
		this.Year = data.Year;
	}

	public getJSON(){
		return {
			ID: this.ID,
			Code: this.Code,
			Amount: this.Amount,
			Year: this.Year
		};
	}
}